import { Box } from '@ksyos/design-system';
import type { orthoServices } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums/serviceCode';
import { NewProcessButton } from './NewProcessButton';
import { ProcessStartWizardButtonRowLayout } from './ProcessStartWizardButtonRowLayout';

interface IOrthopticsServicesButtonRowProps {
    onClick: (name: any) => void;
    selectedService?: orthoServices;
    services: orthoServices[];
}

export function OrthopticsServicesButtonRow(props: IOrthopticsServicesButtonRowProps) {
    const { onClick, selectedService, services } = props;

    return (
        <ProcessStartWizardButtonRowLayout>
            {services.map((item) => {
                return (
                    <Box
                        key={item.code}
                        order={item.code === ServiceCode.OrthO ? 1 : 2}
                    >
                        <NewProcessButton
                            automation={`processFlowService-${item.serviceType}`}
                            data={{ name: item.code }}
                            name={item.name}
                            onClick={onClick}
                            previousSelection={selectedService?.code}
                        />
                    </Box>
                );
            })}
        </ProcessStartWizardButtonRowLayout>
    );
}
